export const PERSIAN_DIGITS = [
  '۰',
  '۱',
  '۲',
  '۳',
  '۴',
  '۵',
  '۶',
  '۷',
  '۸',
  '۹'
]


/**
 * Arabic numeric characters
 */
export const ARABIC_DIGITS = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩']
/**
 * Character code of Persian zero char
 */
export const PERSIAN_ZERO_CHAR_CODE = PERSIAN_DIGITS[0].charCodeAt(0)
/**
 * Character code of Arabic zero char
 */
export const ARABIC_ZERO_CHAR_CODE = ARABIC_DIGITS[0].charCodeAt(0)

export function isValidMobile(number) {
  return /^(\+?(98|\u06F9\u06F8)[-\s]?|(0|\u06F0))(9|\u06F9)[0-39\u06F0-\u06F3\u06F9][0-9\u06F0-\u06F9][-\s]?[0-9\u06F0-\u06F9]{3}[-\s]?[0-9\u06F0-\u06F9]{4}$/.test(number)
}

export function toPersianDigits(value) {
  return String(value).replace(/[0-9]/g, (w) => PERSIAN_DIGITS[parseInt(w, 10)])
}

export function toEnglishDigits(value) {
  return String(value)
    //@ts-ignore
    .replace(/[۰-۹]/g, (w) => w.charCodeAt(0) - PERSIAN_ZERO_CHAR_CODE)
    .replace(/[٠-٩]/g, (w) => w.charCodeAt(0) - ARABIC_ZERO_CHAR_CODE)
}

export function toSignNumber(value) {
  let numberSign = '';
  if (value > 0) {
    numberSign = '+';
  } else if (value > 0) {
    numberSign = '-';
  }
  value = (!isNaN(value) && value != null) ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + numberSign : '';
  return value;
}

export function toSplitNumber(value) {
  value = (typeof value === 'string') ? value.replace(/,/g, "") : value;
  value = (!isNaN(value) && value != null) ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
  return value;
}
